// extracted by mini-css-extract-plugin
export default {"Footer":"FooterStyle_Footer__KU7er"};